<template>
  <i-page class="dialog-details page">
    <div>
      <div class="dialog-details-title">底色</div>
      <q-toggle v-model="isDark" :label="darkToggleLabel" />
    </div>
    <div v-for="cat of themeColorsCategories" :key="cat.value">
      <div class="dialog-details-title">{{cat.text}}</div>
      <div class="theme-items">
        <b-theme-color v-for="item of cat.items" class="theme-item" :key="item.value" :color="item.value" :color-version="colorVersion" />
      </div>
    </div>
  </i-page>
</template>

<script>
import { ThemeColor, ThemeColorCategory } from '@/lib/enums'
import BThemeColor from './BThemeColor.vue'
import _ from 'lodash'

export default {
  components: { BThemeColor },
  data () {
    return {
      colorVersion: 0
    }
  },
  computed: {
    isDark: {
      get () {
        return this.$q.dark.isActive
      },
      set (value) {
        this.$q.dark.set(value)
        this.$nextTick(() => {
          this.colorVersion += 1
        })
      }
    },
    darkToggleLabel () {
      return this.isDark ? '暗黑' : '亮白'
    },
    themeColorsCategories () {
      return _.toPairs(_.groupBy(ThemeColor.items, item => item.meta.category)).map(pair => {
        const cat = ThemeColorCategory.getItem(pair[0])
        return {
          ...cat,
          items: pair[1]
        }
      })
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 800px;
  height: 700px;
  padding: 1em;
}
.theme-items {
  display: flex;
  flex-flow: row wrap;
}
.theme-item {
  margin: 1em 1em 0;
}
</style>
